import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ConfirmationService, Message, TreeNode } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { Permissao } from 'src/app/admihair/api/dto/permissao';
import { CategoriaPermissao } from 'src/app/admihair/api/dto/categoria-permissao';
import { CategoriaPermissaoService } from 'src/app/admihair/service/categoria-permissao.service';
import { CategoriaPermissaoAgrupada } from 'src/app/admihair/api/dto/categoria-permissao-agrupada';
import { TreeTable } from 'primeng/treetable';
import { Administradora } from 'src/app/admihair/api/dto/administradora';
import { UsuarioPermissaoAdministradoraService } from 'src/app/admihair/service/usuario-permissao-administradora.service';
import { UsuarioPermissaoAdministradoraRequest } from 'src/app/admihair/api/dto/usuario-permissao-administradora-request';


@Component({
  selector: 'app-usuario-franquia-rfarias-editar',
  templateUrl: './usuario-franquia-rfarias-editar.component.html',
  styleUrls: ['./usuario-franquia-rfarias-editar.component.scss']
})
export class UsuarioFranquiaRfariasEditarComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;

  loading: boolean = false;
  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo' }];
  messagemVisivel: boolean = false;
  @Output() emissor = new EventEmitter();
  @Input() administradora?: Administradora;
  @Input() id?: number;

  usuario?: Usuario;
  emailConsulta?: string;
  cpfConsulta?: string;
  tiposBusca: string[] = ['CPF', 'E-mail'];
  buscaSelecionada: string = 'E-mail';

  exibirDialogPermissao: boolean = false;
  exibirSpinnerDialog: boolean = false;
  exibirSpinnerTree: boolean = false;
  progressoRequisicao: boolean = false;

  colunasTreeTableDialog: any[] = [];
  categoriasTreeTableDialog: TreeNode[] = [];
  categoriasTreeTableDialogSelecionada: TreeNode[] = [];

  colunasTreeTableSalvas: any[] = [];
  categoriasTreeTableSalvas: TreeNode[] = [];
  categoriasTreeTableSalvasSelecionada: TreeNode[] = [];

  categoriasPermissaoAgrupadaBackend: CategoriaPermissaoAgrupada[] = [];

  constructor(private usuarioService: UsuarioService,
    private categoriaPermissaoService: CategoriaPermissaoService,
    private usuarioPermissaoAdministradoraService: UsuarioPermissaoAdministradoraService,
    private confirmationService: ConfirmationService,
    private erroService: ErroService
  ) { }

  ngOnInit(): void {
    this.exibirSpinnerTree = true;
    this.inicializarColunas();
    this.carregarUsuarioPorId();
  }

  inicializarColunas() {
    this.colunasTreeTableDialog = [
      { field: 'descricao', header: 'Permissão' }
    ];
    this.colunasTreeTableSalvas = [
      { field: 'descricao', header: 'Permissão' }
    ];
  }


  carregarUsuarioPorId() {
    this.usuarioService.buscarPorId(this.id).subscribe({
      next: (data: Usuario) => {
        this.usuario = data;
        this.messagemVisivel = false;
        this.listarCategoriasSalvas();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  atualizarPermissoes() {
    this.progressoRequisicao = true;

    let permissoes: Permissao[] = [];
    for (const item of this.categoriasTreeTableSalvas) {
      if (item.children) {
        for (const filho of item.children) {
          permissoes.push(filho.data);
        }
      }
    }

    const listaPermissoesId: number[] = [];
    for (const item of permissoes) {
      if (item.id) {
        listaPermissoesId.push(item.id);
      }
    }

    const usuarioPerm: UsuarioPermissaoAdministradoraRequest = {
      administradoraId: this.administradora?.id,
      usuarioId: this.usuario?.id,
      permissoesId: listaPermissoesId
    }

    this.usuarioPermissaoAdministradoraService.atualizarPermissoes(usuarioPerm).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })

  }

  listarCategoriasSalvas() {
    this.categoriaPermissaoService.listarAdicionadasPorUsuarioETipoFranquia(this.administradora?.id, this.usuario?.id).subscribe({
      next: (data: CategoriaPermissaoAgrupada[]) => {
        this.exibirSpinnerTree = false;
        this.categoriasTreeTableSalvas = this.converterParaTreeNode(data);
        this.categoriasPermissaoAgrupadaBackend = data;
      },
      error: (err: any) => {
        this.exibirSpinnerTree = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }


  listarCategoriasPermissoesDisponiveis() {
    this.exibirSpinnerDialog = true;
    this.categoriaPermissaoService.listarNaoAdicionadasPorUsuarioETipoFranquia(this.administradora?.id, this.id).subscribe({
      next: (data: CategoriaPermissaoAgrupada[]) => {
        this.exibirSpinnerDialog = false;
        this.categoriasTreeTableDialog = this.converterParaTreeNode(data)
      },
      error: (err: any) => {
        this.exibirSpinnerDialog = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  adicionarPermissao() {

    this.categoriasTreeTableSalvas = this.converterParaTreeNode(this.categoriasPermissaoAgrupadaBackend);

    let permissoes: Permissao[] = [];
    for (const item of this.categoriasTreeTableDialogSelecionada) {
      if (!item.children) {
        if (!permissoes.some(perm => perm.id === item.data.id)) {
          permissoes.push(item.data)
        }
      }
    }

    for (const item of this.categoriasTreeTableSalvas) {
      if (item.children) {
        let filhos = item.children;
        for (const itemFilho of filhos) {
          if (!permissoes.some(perm => perm.id === itemFilho.data.id)) {
            permissoes.push(itemFilho.data)
          }
        }
      }
    }

    let categoriaAgrupadas = this.extrairCategoriaPermissaoAgrupadoDeTreeTable(permissoes);
    this.categoriasTreeTableSalvas = this.converterParaTreeNode(categoriaAgrupadas);
    this.exibirDialogPermissao = false;

  }

  extrairCategoriaPermissaoAgrupadoDeTreeTable(listaPermissoes?: Permissao[]): CategoriaPermissaoAgrupada[] {
    if (listaPermissoes) {
      let categoriasPermissoes: CategoriaPermissao[] = [];
      for (const perm of listaPermissoes) {
        if (perm.categoriaPermissao) {
          if (!categoriasPermissoes.some(categoria => categoria.id === perm.categoriaPermissao?.id)) {
            categoriasPermissoes.push(perm.categoriaPermissao);
          }
        }
      }
      let categoriasPermissoesAgrupadas: CategoriaPermissaoAgrupada[] = [];

      for (const item of categoriasPermissoes) {
        let permissoesList: Permissao[] = [];
        for (const itemPerm of listaPermissoes) {
          if (itemPerm.categoriaPermissao?.id === item.id) {
            permissoesList.push(itemPerm);
          }
        }
        let categoriaPermissaoAgrupadaItem: CategoriaPermissaoAgrupada = {
          id: item.id,
          descricao: item.descricao,
          permissoes: permissoesList
        }
        categoriasPermissoesAgrupadas.push(categoriaPermissaoAgrupadaItem);
      }

      return categoriasPermissoesAgrupadas;
    }
    return [];
  }

  extrairPermissoesDeTree(listaTree?: TreeNode[]) {
    let permissoes: Permissao[] = [];
    if (listaTree) {
      for (const item of listaTree) {
        if (!item.children) {
          if (!permissoes.some(perm => perm.id === item.data.id)) {
            permissoes.push(item.data)
          }
        }
      }
    }
    return permissoes;
  }

  excluir() {
    const permissoes: Permissao[] = this.extrairPermissoesDeTree(this.categoriasTreeTableSalvasSelecionada);
    const permissoesIdExcluir: number[] = [];
    for (const item of permissoes) {
      if (item.id) {
        permissoesIdExcluir.push(item.id);
      }
    }

    const usuarioPermExcluirRequest: UsuarioPermissaoAdministradoraRequest = {
      administradoraId: this.administradora?.id,
      usuarioId: this.usuario?.id,
      permissoesId: permissoesIdExcluir
    }

    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.exibirSpinnerTree = true;
        this.usuarioPermissaoAdministradoraService.excluirListaPermissoes(usuarioPermExcluirRequest).subscribe({
          next: () => {
            this.listarCategoriasSalvas();
            this.messages = this.erroService.handleSuccess();
            this.messagemVisivel = true;
            this.rolarTela();
          },
          error: (err: any) => {
            this.exibirSpinnerTree = false;
            this.messages = this.erroService.handleErro(err);
            this.messagemVisivel = true;
            this.rolarTela();
          }
        })
      }
    });
  }

  converterParaTreeNode(categorias: CategoriaPermissaoAgrupada[]): TreeNode[] {
    return categorias.map(categoria => ({
      data: categoria,
      children: categoria.permissoes ? categoria.permissoes.map(permissao => ({
        data: permissao,
        leaf: true
      })) : []
    }));
  }

  abrirDialogPermissao() {
    this.exibirDialogPermissao = true;
    this.listarCategoriasPermissoesDisponiveis();
  }

  voltar() {
    this.emissor.emit({
      modo: 'LISTAR'
    });
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  buscar(table: TreeTable, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

   limpar(table: TreeTable) {
    table.filterGlobal('', 'contains');
    this.filter.nativeElement.value = '';
  }
}
